// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { atmosphereFragmentDeclaration } from "../Shaders/ShadersInclude/atmosphereFragmentDeclaration";
import { atmosphereUboDeclaration } from "../Shaders/ShadersInclude/atmosphereUboDeclaration";
import { helperFunctions } from "core/Shaders/ShadersInclude/helperFunctions";
import { intersectionFunctions } from "core/Shaders/ShadersInclude/intersectionFunctions";
import { atmosphereFunctions } from "../Shaders/ShadersInclude/atmosphereFunctions";

const name = "skyViewPixelShader";
const shader = `#define RENDER_SKY_VIEW
precision highp float;precision highp sampler2D;
#include<__decl__atmosphereFragment>
uniform sampler2D transmittanceLut;uniform sampler2D multiScatteringLut;
#include<helperFunctions>
#include<atmosphereFunctions>
varying vec2 uv;void main() {gl_FragColor=renderSkyView(uv,transmittanceLut,multiScatteringLut);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
const includes = [atmosphereFragmentDeclaration, atmosphereUboDeclaration, helperFunctions, intersectionFunctions, atmosphereFunctions];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStore[inc.name]) {
        ShaderStore.IncludesShadersStore[inc.name] = inc.shader;
    }
}

/** @internal */
export const skyViewPixelShader = { name, shader };
